module.exports = __webpack_public_path__ + "img/huodongbanshou_dl006x.asm.88ef5bd6.jpg";